/* eslint-disable max-len */
import React from 'react';


export const UserBooksIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <g fill="none"><path stroke="#BE5B04" strokeWidth="1.5" d="M11 7.75c-.69 0-1.25.56-1.25 1.25v13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25H11z" />
      <path fill="#BE5B04" d="M12 7h6v9l-2.959-2L12 16z" />
    </g>
  </svg>
);

export const ActiveUserBooksIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <g fill="none"><path stroke="#383434" strokeWidth="1.5" d="M11 7.75c-.69 0-1.25.56-1.25 1.25v13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25H11z" />
      <path fill="#383434" d="M12 7h6v9l-2.959-2L12 16z" />
    </g>
  </svg>
);
